export const getUrlParams = (url: string) => {
  return url.includes('?') ? url.slice(url.lastIndexOf('?') + 1) : '';
};

export const urlParamsToObject = (params: string) => {
  const urlParams = new URLSearchParams(params);

  return Array.from(urlParams).reduce(
    (acc, [key, value]) => ({
      ...acc,
      [key]: value,
    }),
    {},
  );
};

export const objectToUrlParams = <T = Record<string, unknown>>(params: T) => {
  return Object.keys(params)
    .map((key) => `${key}=${params[key]}`)
    .join('&');
};

export const isUrlFromCloudFront = (url: string): boolean => {
  const playerCloudfront = process.env.CLOUDFRONT_URL as string;
  return url.startsWith(playerCloudfront);
};
